import React from 'react'

import styled from 'styled-components'

import type { ButtonProps } from './Button'
import { Button } from './Button'

export interface ButtonWithIconProps extends ButtonProps {
  as?: React.ElementType
  forwardedAs?: React.ElementType
  icon?: NonNullable<React.ReactNode>
  iconPosition?: 'start' | 'end'
}

const StyledButton = styled(Button)`
  gap: 4px;
`

const IconWrapperSpan = styled.span`
  display: inherit;
  align-items: inherit;

  svg {
    flex-shrink: 0;
  }
`

// TODO left-padding control by size
// TODO icon size control by size
const PureButtonWithIcon = React.forwardRef<HTMLButtonElement, ButtonWithIconProps>(
  ({ icon, children, as, forwardedAs, iconPosition = 'start', ...rest }, ref) => {
    return (
      <StyledButton {...rest} ref={ref} as={as} forwardedAs={forwardedAs}>
        <>
          {icon && iconPosition === 'start' && <IconWrapperSpan>{icon}</IconWrapperSpan>}
          {children}
          {icon && iconPosition === 'end' && <IconWrapperSpan>{icon}</IconWrapperSpan>}
        </>
      </StyledButton>
    )
  }
)

PureButtonWithIcon.displayName = 'PureButtonWithIcon'

// need to handle forwardedAs
export const ButtonWithIcon = styled(PureButtonWithIcon)``
